import type { ShareReportResponse } from '@safetyhub/shared';
import api, { type ApiResponse } from './api';

/**
 * 공유 토큰으로 보고서 조회 (@Public — `GET /share/:token`).
 *
 * 공유 페이지(`pages/share/[token].tsx`)와 확정 전 인쇄 미리보기(`composed-print-preview.tsx` —
 * Puppeteer는 쿠키가 없어 인증 API를 못 쓴다)가 같은 응답을 각자 raw `api.get`으로 치던 것을
 * 한 자리로 모았다 — raw `api.get`으로 각자 치지 말 것. 응답 계약은 shared `ShareReportResponse` 하나다.
 *
 * 실패는 **던진다** — 서버가 `REPORT_SHARE_NOT_FOUND`(404)·`REPORT_SHARE_EXPIRED`(410)·
 * `REPORT_SHARE_NOT_APPROVED`를 예외로 내므로 axios가 거부하고, 호출부는 `extractApiError`로
 * 그 코드를 읽는다(2xx인데 `success:false`인 방어 경로도 같은 형상으로 던진다).
 */
export async function getSharedReport(token: string): Promise<ShareReportResponse> {
  const response = await api.get<ApiResponse<ShareReportResponse>>(`/share/${token}`, {
    skipAuth: true,
  } as Parameters<typeof api.get>[1] & { skipAuth: boolean });
  if (!response.data.success || !response.data.data) {
    throw new Error(response.data.error?.message || '보고서를 불러오지 못했습니다.');
  }
  return response.data.data;
}
